'use client';

import { cn } from '@/lib/utils';
import { TypeTitleTimeGrid } from './types/AdmissionType';
import { useToast } from '@/components/ui/use-toast';

export default function TitleTime(props: TypeTitleTimeGrid) {
    const { currentValue, funHnaleder, value, data } = props;

    const { toast } = useToast();

    function funSelectTime() {
        if (data.status !== 'close') {
            funHnaleder(value);
        }

        if (data.status === 'close') {
            toast({
                title: 'این ساعت قبلا انتخاب شده است !',
                variant: 'error',
            });
        }
    }

    return (
        <p
            onClick={funSelectTime}
            className={cn(
                data.status === 'close'
                    ? 'bg-red-16 border-blue-shaded border-[2px]'
                    : `${
                          value === currentValue
                              ? '!bg-blue !border-blue !text-white '
                              : 'bg-[#fff] border-[1px]'
                      }`,
                data.status === 'free' &&
                    '  bg-[#80808000] text-blue transition-colors shadow-sm',
                'px-1.5 py-0.5 rounded-md text-center cursor-pointer min-w-[70px] text-base',
            )}
        >
            {data.status === 'close' ? (
                <span className="line-through">{data.time}</span>
            ) : (
                `${data.time}`
            )}
        </p>
    );
}
